export const MegaMenuController = () => {
  let currentMenu;
  const mainMenu = $('.mega-menu-dropdown');


  $('.mega-menu-item[data-target]').on('mouseenter', (e) => {
    e.preventDefault();
    currentMenu = $(e.currentTarget).attr('data-target');

    $('.mega-menu-item[data-target]').removeClass('is-active');
    $(e.currentTarget).addClass('is-active');

    mainMenu.removeClass('hide').addClass('show');
    $('.mega-menu-dropdown__panel').removeClass('show').addClass('hide');
    $('#' + currentMenu).removeClass('hide').addClass('show');
    $('body').addClass('menu-shown');
  });

  $('.mega-menu-dropdown').on('mouseleave', (e) => {
    closeMenu(mainMenu);
  });
  $('.mega-menu-dropdown__close').on('click', (e) => {
    closeMenu(mainMenu);
  });

  $(document).mouseup(function(e) {
    // if the target of the click isn't the mainMenu nor a descendant of the mainMenu
    if (!mainMenu.is(e.target) && mainMenu.has(e.target).length === 0) {
      closeMenu(mainMenu);
    }
  });

}


const closeMenu = (container) => {
  $('body').removeClass('menu-shown');
  $('.mega-menu-item[data-target]').removeClass('is-active');
  container.removeClass('show').addClass('hide');
}



// WEBPACK FOOTER //
// ./src/js/controllers/MegaMenuController.js